import { Component } from "@angular/core";
import { Spinkit } from "ng-http-loader";
import { NavigationEnd, Router } from "@angular/router";
import { LoginService } from "./services/login.service";
@Component({
  selector: "app-root",
  templateUrl: "./app.component.html",
  styleUrls: ["./app.component.css"],
})
export class AppComponent {
  title = "ClientApp";

  currentUrl: string = window.location.pathname;
  public spinkit = Spinkit;

  public noLoaderRoutes = [
    "/login",
    "/dashboard1",
    "/masters/usermaster",
    "/masters/productmaster",
    "/masters/rolemaster",
    "/masters/productconfiguration",
    "/numberactive/productallocation",
    "/transactions/schemedemapping",
    "/transactions/hologramdamage",
    "/reports/verificationrpt",
    "/reports/mappingrpt",
    "/reports/ratingrpt",
    "/reports/feedbackrpt",
 "/reports/demappingrpt",
 "/reports/damagerpt",
    "/configuration",
  ];
  constructor(public router: Router) {
    this.router.events.subscribe((e) => {
      if (e instanceof NavigationEnd) {
        this.currentUrl = e.urlAfterRedirects.split("?")[0];
      }
    });
  }
  // checkUserExists(): void {
  //   const storedUser = localStorage.getItem("user");
  //   if (storedUser) {
  //     const user = JSON.parse(storedUser);
  //     this.loginService.checkUserExist(user.usrEmail, user.usrId).subscribe((response: any) => {
  //       if (response.responseCode === "200" && response.isUser === false) {
  //         this.router.navigate(["/login"]);
  //         localStorage.clear();
  //       }
  //     });
  //   }
  // }
}
